/**
 * Buttons Interactions
 */

export function initButtons() {
    
    // Filter buttons - Active state toggle
    const filterButtons = document.querySelectorAll('[data-products-filters] .btn-lg-rouge');
    
    if (filterButtons.length) {
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons in this group
                filterButtons.forEach(btn => btn.classList.remove('active'));
                
                // Add active class to clicked button
                button.classList.add('active');
            });
        });
    }
    
    // Language dropdowns (both mobile and desktop)
    const langButtons = document.querySelectorAll('[data-lang-button]');
    const langDropdowns = document.querySelectorAll('[data-lang-dropdown]');
    
    langButtons.forEach((langButton, index) => {
        const langDropdown = langDropdowns[index];
        if (!langDropdown) return;
        
        const langOptions = langDropdown.querySelectorAll('[data-lang-option]');
        console.log(langOptions);
        
        // Toggle dropdown on click
        langButton.addEventListener('click', (e) => {
            e.stopPropagation();
            
            // Close all other dropdowns first
            langDropdowns.forEach((dropdown, i) => {
                if (i !== index) {
                    dropdown.classList.add('hidden');
                    langButtons[i].querySelector('svg').classList.remove('rotate-180');
                }
            });
            
            // Toggle current dropdown
            langDropdown.classList.toggle('hidden');
            langButton.querySelector('svg').classList.toggle('rotate-180');
        });
        
        // Handle language selection
        langOptions.forEach(option => {
            option.addEventListener('click', () => {
                const selectedLang = option.dataset.langOption;
                
                // Get WPML language URL if available
                const langUrl = option.dataset.langUrl;
                
                if (langUrl) {
                    // If we have a WPML URL, redirect to it
                    window.location.href = langUrl;
                } else {
                    // Fallback: construct URL based on language code
                    // This assumes WPML is using directory format (/en/, /fr/, etc.)
                    const currentPath = window.location.pathname;
                    const currentLangMatch = currentPath.match(/^\/([a-z]{2})\//);
                    let newPath = currentPath;
                    
                    const langCode = selectedLang.toLowerCase();
                    
                    if (currentLangMatch) {
                        // Replace existing language code
                        newPath = currentPath.replace(/^\/[a-z]{2}\//, `/${langCode}/`);
                    } else {
                        // Add language code
                        newPath = `/${langCode}${currentPath}`;
                    }
                    
                    window.location.href = window.location.origin + newPath + window.location.search;
                }
            });
        });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', () => {
        langDropdowns.forEach(dropdown => {
            dropdown.classList.add('hidden');
        });
        langButtons.forEach(btn => {
            btn.querySelector('svg').classList.remove('rotate-180');
        });
    });
}